import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  TREQUEST_DELETE_MACHINE,
  TREQUEST_MACHINE_LIST,
  TREQUEST_UPDATE_MACHINE,
  TRESPONSE_MACHINE_LIST,
  TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN,
  TREQUEST_EMPLOYEE_LIST,
  TREQUEST_DELETE_EMPLOYEE,
  TREQUEST_UPDATE_EMPLOYEE,
  TREQUEST_GET_ASSIGNABLE_SHIFTS_FOR_EMPLOYEE,
  TRESPONSE_GET_ASSIGNABLE_SHIFTS_FOR_EMPLOYEE,
  TRESPONSE_EMPLOYEE_LIST,
  TREQUEST_LOCATION_LIST,
  TRESPONSE_LOCATION_LIST,
  TREQUEST_DELETE_LOCATION,
  TREQUEST_ASSIGN_EMPLOYEE,
  TRESPONSE_GET_ASSSIGN_EMPLOYEE_DROPDOWN,
  TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN,
  TFactoryId,
  TREQUEST_BULK_ASSIGN_LOCATIONS,
  TREQUEST_BULK_UPDATE_STATUS,
  TREQUEST_BREAKDOWN_REASON_LIST,
  TRESPONSE_BREAKDOWN_REASON_LIST,
  TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN,
  TREQUEST_DELETE_BREAKDOWN_REASON,
  TREQUEST_EDIT_BREAKDOWN_REASON,
  TREQUEST_MACHINE_TRANSFER,
  TRESPONSE_MACHINE_TRANSFER_DROPDOWN,
  TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION,
  TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS,
  TREQUEST_ADD_NEW_WORKSTATION,
  TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA,
  TREQUEST_ASSIGN_MACHINE_TO_WORKSTATION,
  TREQUEST_REMOVE_MACHINE_FROM_WORKSTATION,
  TREQUEST_REPLACE_MACHINE_FROM_WORKSTATION,
  TREQUEST_REMOVE_WORKSTATION,
  TREQUEST_RESET_FACTORY_PRODUCTION_AREA,
  TRESPONSE_GET_MACHINE_AND_LINE_DETAILS,
  TREQUEST_CREATE_TICKET,
  TREQUEST_REASSIGN_MECHANIC,
  TTicketId,
  TRESPONSE_GET_EMPLOYEE_TICKET_SUMMARY,
  TREQUEST_GET_ALL_EMPLOYEE_TICKETS,
  TRESPONSE_GET_ALL_EMPLOYEE_TICKETS,
  TRESPONSE_GET_MACHINE_TICKET_HISTORY,
  TREQUEST_GET_MACHINE_TICKET_HISTORY,
  TRESPONSE_BREAKDOWN_REASON_SOLUTION_LIST,
  TREQUEST_UPDATE_ISSUE,
  TRESPONSE_GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST,
  TRESPONSE_GET_FLOATING_AREA_MCHINES_BY_LOCATION,
  TREQUEST_GET_MACHINE_AND_LINE_DETAILS,
  TREQUEST_BREAKDOWN_REASON_SOLUTION_LIST,
  TRESPONSE_GET_SHIFT_DETAILS,
  TShiftRevision,
  TREQUEST_ADD_REVISION,
  TREQUEST_GET_LOCATION_SHIFTS,
  TRESPONSE_GET_LOCATION_SHIFTS,
  TREQUEST_UPDATE_REVISION,
  TREQUEST_GET_SHIFT_DETAILS,
  TRESPONSE_GET_ALL_SHIFT_SCHEDULE_LINE_LOCATIONS,
  TREQUEST_MACHINE_SERVICE_LIST,
  TRESPONSE_MACHINE_SERVICE_LIST,
  TREQUEST_UPDATE_MACHINE_SERVICE_TASKS,
  TREQUEST_GET_ALL_MAINTENANCE_TICKETS,
  TREQUEST_CREATE_MAINTENANCE_TICKET,
  TREQUEST_START_MAINTENANCE_TICKET,
  TREQUEST_COMPLETE_MAINTENANCE_TICKET,
  TRESPONSE_GET_ALL_MAINTENANCE_TICKETS,
  TDOWNLOAD_LISTING_DATA_PAYLOAD,
  TExcelContext,
  TREQUEST_MACHINE_TRANSFER_DROPDOWN,
  TREQUEST_REASSIGN_MAINTENANCE_MECHANIC,
  TREQUEST_SPAREPART_LIST,
  TRESPONSE_SPAREPART_LIST,
  TREQUEST_DELETE_SPAREPART,
  TREQUEST_UPDATE_SPAREPART,
  TREQUEST_SPAREPART_REQUEST_LIST,
  TRESPONSE_SPAREPART_REQUEST_LIST,
  TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS,
  TREQUEST_RAISE_SPAREPART_REQUEST,
  TREQUEST_GET_SPAREPART_REQUEST_BY_SOURCE,
  TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE,
  TRESPONSE_SPAREPART_SEARCH_NAMES,
  TRaiseARequestId,
  GET_SPAREPART_REQUEST_REASONS,
  TREQUEST_MARK_CHECKLIST_COMPLETED,
  TREQUEST_NEEDLE_LIST,
  TRESPONSE_NEEDLE_LIST,
  TREQUEST_NEEDLE_UPDATE,
  TREQUEST_NEEDLE_DELETE,
  TRAISE_NEEDLE_REQUEST,
  TRESPONSE_GET_LOCAL_NEEDLE_STORES,
  TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN,
  TREQUEST_ASSIGN_NEEDLE_STORES,
  TRESPONSE_NEEDLE_SEARCH,
  TREQUEST_ADD_MACHINE_NEEDLES,
  TREQUEST_REMOVE_MACHINE_NEEDLES,
  TREQUEST_RAISE_NEEDLE_REQUEST,
  TRESPONSE_GET_NEEDLE_REQUESTS,
  TREQUEST_NEEDLE_APPROVE,
  TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST,
  TREQUEST_EMPLOYEE_REPLACEMENTS,
  TREQUEST_BULK_UPDATE_PRINTED_STATUS,
  TREQUEST_EMPLOYEE_REPLACEMENTS_FOR_TICKETS,
  TREQUEST_SUMMARY,
  TREQUEST_SUMMARY_ANALYTICS,
  TRESPONSE_GET_TICKET_SUMMARY_ANALYTICS,
  TRESPONSE_GET_MAINTENANCE_TICKET_HISTORY,
  TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN,
  TREQUEST_TRANSFER_MACHINE_TO_SIBLING_FACTORY,
  TREQUEST_TRANSFER_BETWEEN_FLOATING_AREAS,
  TREQUEST_BULK_UPDATE_PREVENTIVE_SCHEDULE,
  TREQUEST_RETURN_MACHINES_TO_VENDOR,
  TREQUEST_REACTIVATE_RETURNED_MACHINES,
  TRESPONSE_GET_EMPLOYEE_TICKET_DETAILS,
  TRESPONSE_MECHANIC_DASHBOARD,
  TREQUEST_HOLIDAY_LIST,
  TRESPONSE_HOLIDAY_LIST,
  TREQUEST_ADD_HOLIDAYS,
  TREQUEST_DELETE_HOLIDAYS,
  TREQUEST_UPDATE_SPAREPART_THRESHOLD,
  TREQUEST_UPDATE_SPAREPART_CRITICAL,
  TREQUEST_EDIT_HOLIDAY,
  TREQUEST_LINES_NPT_DETAILS,
  TRESPONSE_LINES_NPT_DETAILS,
  TREQUEST_WORKSTATIONS_NPT_DETAILS,
  TRESPONSE_WORKSTATIONS_NPT_DETAILS,
  TREQUEST_NPT_CREATE,
  TREQUEST_NPT_DELETE,
  TREQUEST_NPT_EDIT,
  TREQUEST_WORKSTATION_NPTS,
  TRESPONSE_WORKSTATION_NPTS,
  TREQUEST_GET_ALL_BRANDS_AND_SPECIFICATIONS,
  TRESPONSE_GET_ALL_BRANDS_AND_SPECIFICATIONS,
  TREQUEST_NPT_REASONS_LIST,
  TRESPONSE_NPT_REASONS_LIST,
  TREQUEST_NPT_SUBCATEGORY_DELETE,
  TREQUEST_ATTACHMENT_LIST,
  TRESPONSE_ATTACHMENT_LIST,
  TREQUEST_ATTACHMENT_DELETE,
  TREQUEST_ATTACHMENT_PRINT_QR,
  TREQUEST_ATTACHMENT_UPDATE,
  TREQUEST_ATTACHMENT_APPROVAL_LIST,
  TRESPONSE_ATTACHMENT_APPROVAL_LIST,
  TREQUEST_ATTACHMENT_ACTION,
  TREQUEST_ATTACHMENT_APPROVAL_ACTION,
  TAttachmentSerialNumber,
  TRESPONSE_GET_ATTACHMENT_DETAILS_BY_SERIAL_NUM,
  TREQUEST_KNOWLEDGE_BASE_SUBMIT_FEEDBACK,
  TREQUEST_KNOWLEDGE_BASE_QUESTION,
  TRESPONSE_KNOWLEDGE_BASE_QUESTION,
  DISABLE_ERROR_ALERT_HEADER,
  TREQUEST_PARTIAL_APPROVE_SPAREPART_REQUEST,
  TRESPONSE_GET_BRAND_AND_TYPE_BY_NEEDLE_NUMBER,
  TRESPONSE_GET_BRANDS_AND_TYPES_BY_NEEDLE_NUMBER,
  TRESPONSE_ISSUE_CATEGORIES_AND_MACHINE_TYPE_DROPDOWN_INFO,
  TRESPONSE_LINE_SETUP_TICKET_LISTING,
  TRESPONSE_LINE_SETUP_TICKET_DETAILS,
  TREQUEST_LINE_SETUP_TICKET_DELETE,
  TREQUEST_LINE_SETUP_TICKET_UPDATE_MECHANIC,
  TREQUEST_LINE_SETUP_TICKET_UPDATE,
  TREQUEST_LINE_SETUP_TICKET_SUBTASK_CREATE,
  TREQUEST_LINE_SETUP_TICKET_SUBTASK_DELETE,
  TREQUEST_LINE_SETUP_TICKET_SUBTASK_LIST,
  TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST,
  TREQUEST_LINE_SETUP_TICKET_LISTING,
  TRESPONSE_GET_ALL_ASSIGNED_MECHANICS_FOR_LOCATION,
  TLineSetupTicketId,
  TRESPONSE_FACTORY_LEVEL_NPTS,
  TDate,
  TREQUEST_BULK_NPT_CREATE,
  TREQUEST_GET_LINES_SHIFTS,
  TRESPONSE_GET_LINES_SHIFTS,
  TREQUEST_MM_GET_ALL_SHIFTS,
  TRESPONSE_MM_GET_ALL_SHIFTS,
  TREQUEST_ASSIGN_SHIFT_TO_LOCATIONS,
  TREQUEST_CREATE_SHIFT_CATEGORY,
  TREQUEST_CREATE_SHIFT,
  TRESPONSE_GET_SHIFT_CATEGORIES,
  TRESPONSE_GET_FACTORY_TIME_ZONE,
  TRESPONSE_EMPLOYEE_REPLACEMENTS_FOR_MACHINE_ISSUE_TICKETS,
} from '@monorepo/types';
import { MmEnvironmentService } from './mm-environment.service';

@Injectable({
  providedIn: 'root',
})
export class MachineMaintenanceDataService {
  constructor(private http: HttpClient, private mmEnvironmentService: MmEnvironmentService) {}

  downloadAllListingData(excelContext: TExcelContext, payload: TDOWNLOAD_LISTING_DATA_PAYLOAD) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DOWNLOAD_LISTING_DATA').replace(':context', excelContext);
    return this.http.post(url, payload, { responseType: 'blob' });
  }

  //Machine list APIs

  fetchMachineListData(payload: TREQUEST_MACHINE_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_MACHINE_LIST_DATA');
    return this.http.post<TRESPONSE_MACHINE_LIST>(url, payload);
  }

  getMachineListFilterDropDownValues(factoryId: TFactoryId) {
    const url = this.mmEnvironmentService.getUrlFromEnv('MACHINE_LIST_FILTER_DROPDOWN_VALUES');
    const updatedUrl = url.replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_UPDATE_MACHINE_FIELD_DROPDOWN>(updatedUrl);
  }

  deleteMachines(payload: TREQUEST_DELETE_MACHINE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_MACHINES');
    return this.http.post<TRESPONSE_MACHINE_LIST>(url, payload);
  }

  updateMachine(payload: TREQUEST_UPDATE_MACHINE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_MACHINE');
    return this.http.post<TRESPONSE_MACHINE_LIST>(url, payload);
  }

  bulkUpdateMachineStatus(payload: TREQUEST_BULK_UPDATE_STATUS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('BULK_UPDATE_MACHINE_STATUS');
    return this.http.post(url, payload);
  }

  bulkUpdateMachineQRPrintedStatus(payload: TREQUEST_BULK_UPDATE_PRINTED_STATUS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('BULK_UPDATE_MACHINE_QR_PRINTED_STATUS');
    return this.http.post(url, payload);
  }

  getBulkLocationDropdown(factoryId: TFactoryId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_LOCATIONS_FOR_NEW_MACHINES')
      .replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_GET_BULK_ASSIGN_LOCATIONS_DROPDOWN>(url);
  }

  assignBulkLocation(payload: TREQUEST_BULK_ASSIGN_LOCATIONS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ADD_MACHINE_LOCATION');
    return this.http.post(url, payload);
  }

  getMachineTransferDropdown(payload: TREQUEST_MACHINE_TRANSFER_DROPDOWN) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_MACHINE_TRANSFER_DETAILS');
    return this.http.post<TRESPONSE_MACHINE_TRANSFER_DROPDOWN>(url, payload);
  }

  transferToExternalLocation(payload: TREQUEST_MACHINE_TRANSFER) {
    const url = this.mmEnvironmentService.getUrlFromEnv('TRANSFER_MACHINE_TO_EXTERNAL_LOCATION');
    return this.http.post(url, payload);
  }

  getMachineAndLineDetails(payload: TREQUEST_GET_MACHINE_AND_LINE_DETAILS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_MACHINE_AND_LOCATION_DETAILS');
    return this.http.post<TRESPONSE_GET_MACHINE_AND_LINE_DETAILS>(url, payload);
  }

  getSiblingFactories() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_SIBLING_FACTORIES');
    return this.http.get<TRESPONSE_GET_SIBLING_FACTORIES_DROPDOWN>(url);
  }

  transferToSiblingFactory(payload: TREQUEST_TRANSFER_MACHINE_TO_SIBLING_FACTORY) {
    const url = this.mmEnvironmentService.getUrlFromEnv('TRANSFER_MACHINE_TO_SIBLING_FACTORY');
    return this.http.post(url, payload);
  }

  transferBetweenFloatingAreas(payload: TREQUEST_TRANSFER_BETWEEN_FLOATING_AREAS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('TRANSFER_MACHINE_BETWEEN_FLOATING_AREAS');
    return this.http.post<void>(url, payload);
  }

  bulkUpdatePreventiveSchedule(payload: TREQUEST_BULK_UPDATE_PREVENTIVE_SCHEDULE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('BULK_UPDATE_PREVENTIVE_SCHEDULE');
    return this.http.post(url, payload);
  }

  returnMachinesToVendor(payload: TREQUEST_RETURN_MACHINES_TO_VENDOR) {
    const url = this.mmEnvironmentService.getUrlFromEnv('RETURN_MACHINES_TO_VENDOR');
    return this.http.post<void>(url, payload);
  }

  reactivateReturnedMachines(payload: TREQUEST_REACTIVATE_RETURNED_MACHINES) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REACTIVATE_RETURNED_MACHINES');
    return this.http.post<void>(url, payload);
  }

  //Sparepart list APIs
  fetchSparePartListData(payload: TREQUEST_SPAREPART_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_SPAREPART_LIST_DATA');
    return this.http.post<TRESPONSE_SPAREPART_LIST>(url, payload);
  }

  deleteSpareParts(payload: TREQUEST_DELETE_SPAREPART) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_SPAREPART');
    return this.http.post<TRESPONSE_SPAREPART_LIST>(url, payload);
  }

  updateSparePart(payload: TREQUEST_UPDATE_SPAREPART) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_SPAREPART');
    return this.http.post<TRESPONSE_SPAREPART_LIST>(url, payload);
  }

  bulkUpdateSparePartThreshold(payload: TREQUEST_UPDATE_SPAREPART_THRESHOLD) {
    const url = this.mmEnvironmentService.getUrlFromEnv('BULK_UPDATE_SPAREPART_THRESHOLD');
    return this.http.post<TRESPONSE_SPAREPART_LIST>(url, payload);
  }

  bulkUpdateSparePartCritical(payload: TREQUEST_UPDATE_SPAREPART_CRITICAL) {
    const url = this.mmEnvironmentService.getUrlFromEnv('BULK_UPDATE_SPAREPART_CRITICAL');
    return this.http.post<TRESPONSE_SPAREPART_LIST>(url, payload);
  }

  //Sparepart request APIs

  fetchSparePartRequestListData(payload: TREQUEST_SPAREPART_REQUEST_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_SPAREPART_REQUEST_LIST_DATA');
    return this.http.post<TRESPONSE_SPAREPART_REQUEST_LIST>(url, payload);
  }

  updateSparePartRequestStatus(payload: TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_SPAREPART_REQUEST_STATUS');
    return this.http.post<TRESPONSE_SPAREPART_REQUEST_LIST>(url, payload);
  }

  sparePartRequestPartialApprove(payload: TREQUEST_PARTIAL_APPROVE_SPAREPART_REQUEST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('SPAREPART_REQUEST_PARTIAL_APPROVE');
    return this.http.post<void>(url, payload);
  }

  //Config Setup APIs

  fetchHolidayListData(payload: TREQUEST_HOLIDAY_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_HOLIDAY_LIST');
    return this.http.post<TRESPONSE_HOLIDAY_LIST>(url, payload);
  }

  addHolidays(payload: TREQUEST_ADD_HOLIDAYS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ADD_HOLIDAYS');
    return this.http.post(url, payload);
  }

  deleteHolidays(payload: TREQUEST_DELETE_HOLIDAYS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_HOLIDAYS');
    return this.http.post(url, payload);
  }

  editHoliday(payload: TREQUEST_EDIT_HOLIDAY) {
    const url = this.mmEnvironmentService.getUrlFromEnv('EDIT_HOLIDAYS');
    return this.http.post(url, payload);
  }

  //Employee list APIs

  fetchEmployeeListData(payload: TREQUEST_EMPLOYEE_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_EMPLOYEE_LIST');
    return this.http.post<TRESPONSE_EMPLOYEE_LIST>(url, payload);
  }

  fetchIssueCategoriesAndMachineType() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ISSUE_CATEGORIES_AND_MACHINE_TYPE_DROPDOWN_INFO');
    return this.http.get<TRESPONSE_ISSUE_CATEGORIES_AND_MACHINE_TYPE_DROPDOWN_INFO>(url);
  }

  deleteEmployee(payload: TREQUEST_DELETE_EMPLOYEE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_EMPLOYEE');
    return this.http.post<TRESPONSE_EMPLOYEE_LIST>(url, payload);
  }

  updateEmployee(payload: TREQUEST_UPDATE_EMPLOYEE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_EMPLOYEE');
    return this.http.post<TRESPONSE_EMPLOYEE_LIST>(url, payload);
  }

  getAssignableShiftsForEmployee(payload: TREQUEST_GET_ASSIGNABLE_SHIFTS_FOR_EMPLOYEE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ASSIGNABLE_SHIFTS_FOR_EMPLOYEE');
    return this.http.post<TRESPONSE_GET_ASSIGNABLE_SHIFTS_FOR_EMPLOYEE>(url, payload);
  }

  getEmployeeReplacements(payload: TREQUEST_EMPLOYEE_REPLACEMENTS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_EMPLOYEE_REPLACEMENT');
    return this.http.post<TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS>(url, payload);
  }

  getEmployeeReplacementsForMaintenanceTickets() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_EMPLOYEE_REPLACEMENT_FOR_MAINTENANCE_TICKETS');
    return this.http.get<TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS>(url);
  }

  getEmployeeReplacementsForMachineIssueTicket(payload: TREQUEST_EMPLOYEE_REPLACEMENTS_FOR_TICKETS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_EMPLOYEE_REPLACEMENT_FOR_TICKETS');
    return this.http.post<TRESPONSE_EMPLOYEE_REPLACEMENTS_FOR_MACHINE_ISSUE_TICKETS>(url, payload);
  }

  //Mechanic Dashboard APIs

  fetchMechanicDashboardData() {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_MECHANIC_DASHBOARD');
    return this.http.get<TRESPONSE_MECHANIC_DASHBOARD>(url);
  }

  //Location list APIs

  fetchLocationListData(payload: TREQUEST_LOCATION_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_LOCATION_LIST');
    return this.http.post<TRESPONSE_LOCATION_LIST>(url, payload);
  }

  deleteLocations(payload: TREQUEST_DELETE_LOCATION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_LOCATION');
    return this.http.post<TRESPONSE_LOCATION_LIST>(url, payload);
  }

  fetchAssignEmployeeDropdownData(locationIds: TRESPONSE_LOCATION_LIST['locationDetails'][number]['id'][]) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_EMPLOYEES_BY_LOCATION_IDS');
    return this.http.post<TRESPONSE_GET_ASSSIGN_EMPLOYEE_DROPDOWN>(url, { locationIds });
  }

  assignEmployee(payload: TREQUEST_ASSIGN_EMPLOYEE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ADD_EMPLOYEES');
    return this.http.post<void>(url, payload);
  }

  getFloatingAreaFloorsForLocationDeletion(factoryId: TFactoryId) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_FLOATING_AREAS').replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_FLOATING_AREAS_FOR_LOCATION_DELETION>(url);
  }

  getLocalNeedleStores() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_LOCAL_NEEDLE_STORES');
    return this.http.get<TRESPONSE_GET_LOCAL_NEEDLE_STORES>(url);
  }

  assignNeedleStores(payload: TREQUEST_ASSIGN_NEEDLE_STORES) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ASSIGN_NEEDLE_STORES');
    return this.http.post(url, payload);
  }

  //Breakdown Reasons APIs
  fetchBreakdownReasonListData(payload: TREQUEST_BREAKDOWN_REASON_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_BREAKDOWN_REASONS_LIST');
    return this.http.post<TRESPONSE_BREAKDOWN_REASON_LIST>(url, payload);
    // const test: TRESPONSE_BREAKDOWN_REASON_LIST = {
    //   breakdownReasonsDetail: [
    //     {
    //       machineType: 'SEWING',
    //       machineCategory: 'CL',
    //       machineSubCategory: 'END  CUTTER',
    //       breakdownReasons: [
    //         {
    //           reason: 'Oil leak',
    //           reasonId: 76,
    //         },
    //         {
    //           reason: 'Needle Issue',
    //           reasonId: 71,
    //         },
    //         {
    //           reason: 'Padel Stuck',
    //           reasonId: 69,
    //         },
    //       ],
    //     },
    //     {
    //       machineType: 'SEWING',
    //       machineCategory: 'CL',
    //       machineSubCategory: 'END  CUTTER',
    //       breakdownReasons: [
    //         {
    //           reason: 'Oil leak',
    //           reasonId: 76,
    //         },
    //         {
    //           reason: 'Needle Issue',
    //           reasonId: 71,
    //         },
    //         {
    //           reason: 'Padel Stuck',
    //           reasonId: 69,
    //         },
    //       ],
    //     },
    //     {
    //       machineType: 'SEWING',
    //       machineCategory: 'CL',
    //       machineSubCategory: 'END  CUTTER',
    //       breakdownReasons: [
    //         {
    //           reason: 'Oil leak',
    //           reasonId: 76,
    //         },
    //       ],
    //     },
    //     {
    //       machineType: 'SEWING',
    //       machineCategory: 'CL',
    //       machineSubCategory: 'END  CUTTER',
    //       breakdownReasons: [
    //         {
    //           reason: 'Oil leak',
    //           reasonId: 76,
    //         },
    //         {
    //           reason: 'Needle Issue',
    //           reasonId: 71,
    //         },
    //       ],
    //     },
    //   ],
    //   filters: [
    //     {
    //       displayName: 'Machine Type',
    //       values: [
    //         {
    //           value: 'SEWING',
    //           displayName: 'SEWING',
    //         },
    //         {
    //           value: 'PRESSING',
    //           displayName: 'PRESSING',
    //         },
    //         {
    //           value: 'STORE',
    //           displayName: 'STORE',
    //         },
    //       ],
    //       type: 'MULTI_SELECT_FILTER',
    //       version: 'v2',
    //       key: 'MACHINE_TYPE',
    //     },
    //     {
    //       displayName: 'Category',
    //       values: [
    //         {
    //           value: 'SP',
    //           displayName: 'SP',
    //         },
    //         {
    //           value: 'CL',
    //           displayName: 'CL',
    //         },
    //         {
    //           value: 'NR',
    //           displayName: 'NR',
    //         },
    //       ],
    //       type: 'MULTI_SELECT_FILTER',
    //       version: 'v2',
    //       key: 'CATEGORY',
    //     },
    //     {
    //       displayName: 'Sub-category',
    //       values: [
    //         {
    //           value: 'NEEDLE FEED',
    //           displayName: 'NEEDLE FEED',
    //         },
    //         {
    //           value: 'END  CUTTER',
    //           displayName: 'END  CUTTER',
    //         },
    //         {
    //           value: 'OVER LOCK 5TH',
    //           displayName: 'OVER LOCK 5TH',
    //         },
    //         {
    //           value: 'BOILER',
    //           displayName: 'BOILER',
    //         },
    //       ],
    //       type: 'MULTI_SELECT_FILTER',
    //       version: 'v2',
    //       key: 'SUBCATEGORY',
    //     },
    //     {
    //       displayName: 'Breakdown Reason',
    //       values: [
    //         {
    //           value: 'Oil leak',
    //           displayName: 'Oil leak',
    //         },
    //         {
    //           value: 'Padel Stuck',
    //           displayName: 'Padel Stuck',
    //         },
    //         {
    //           value: 'Thread Breaking',
    //           displayName: 'Thread Breaking',
    //         },
    //         {
    //           value: 'Oil Leak',
    //           displayName: 'Oil Leak',
    //         },
    //         {
    //           value: 'test issue 3',
    //           displayName: 'test issue 3',
    //         },
    //         {
    //           value: 'Needle Issue',
    //           displayName: 'Needle Issue',
    //         },
    //         {
    //           value: 'test issue',
    //           displayName: 'test issue',
    //         },
    //         {
    //           value: 'Needle Breaking',
    //           displayName: 'Needle Breaking',
    //         },
    //         {
    //           value: 'Current Leak',
    //           displayName: 'Current Leak',
    //         },
    //         {
    //           value: 'No Power',
    //           displayName: 'No Power',
    //         },
    //         {
    //           value: 'Motor noise',
    //           displayName: 'Motor noise',
    //         },
    //       ],
    //       type: 'MULTI_SELECT_FILTER',
    //       version: 'v2',
    //       key: 'BREAKDOWN_REASON',
    //     },
    //   ],
    //   paginationInfo: {
    //     totalPageCount: 1,
    //     totalItems: 2,
    //     rangeInPage: {
    //       start: 1,
    //       end: 2,
    //     },
    //   },
    //   userSelectedFilters: [],
    // };
    // return of(test);
  }

  getBreakdownReasonListFilterDropDownValues(factoryId: TFactoryId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('BREAKDOWN_REASONS_FILTER_DROPDOWN')
      .replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN>(url);
    // const a: TRESPONSE_EDIT_BREAKDOWN_REASONS_FIELD_DROPDOWN = {
    //   machineTypes: ['SEWING', 'PRESSING', 'STORE'],
    //   machineCategories: ['SP', 'CL', 'NR'],
    //   machineSubCategories: ['NEEDLE FEED', 'END  CUTTER', 'OVER LOCK 5TH', 'BOILER'],
    //   breakdownReasons: [
    //     {
    //       reason: 'Oil leak',
    //       reasonId: 76,
    //     },
    //     {
    //       reason: 'Needle Issue',
    //       reasonId: 71,
    //     },
    //     {
    //       reason: 'Padel Stuck',
    //       reasonId: 69,
    //     },
    //   ],
    // };
    // return of(a);
  }

  deleteBreakdownReason(payload: TREQUEST_DELETE_BREAKDOWN_REASON) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_BREAKDOWN_REASONS');
    return this.http.post<TRESPONSE_BREAKDOWN_REASON_LIST>(url, payload);
  }

  editBreakdownReason(payload: TREQUEST_EDIT_BREAKDOWN_REASON) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_BREAKDOWN_REASONS');
    return this.http.post<TRESPONSE_BREAKDOWN_REASON_LIST>(url, payload);
  }

  //machine service APIs
  fetchMachineServiceListData(payload: TREQUEST_MACHINE_SERVICE_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('MACHINE_SERVICE_LIST');
    return this.http.post<TRESPONSE_MACHINE_SERVICE_LIST>(url, payload);
  }

  updateMachineServiceTasks(payload: TREQUEST_UPDATE_MACHINE_SERVICE_TASKS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_MACHINE_SERVICE_TASKS');
    return this.http.post(url, payload);
  }

  //line setup APIs

  getFactoryLineWorkstationSummaryList(factoryId: TFactoryId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST')
      .replace(':factoryId', factoryId);
    return this.http.get<TRESPONSE_GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST>(url);
  }

  getFloatingAreaMachinesByLocation(locationId: number) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_FLOATING_AREA_MCHINES_BY_LOCATION')
      .replace(':locationId', String(locationId));
    return this.http.get<TRESPONSE_GET_FLOATING_AREA_MCHINES_BY_LOCATION>(url);
  }

  addNewWorkstation(payload: TREQUEST_ADD_NEW_WORKSTATION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ADD_WORKSTATION');
    return this.http.post<TREQUEST_ADD_NEW_WORKSTATION>(url, payload);
  }

  getAllWorkstationsForProductionArea(
    factoryId: TFactoryId,
    locationId: TRESPONSE_LOCATION_LIST['locationDetails'][number]['id'],
  ) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_ALL_WORKSTATIONS')
      .replace(':factoryId', factoryId)
      .replace(':locationId', locationId.toString());
    return this.http.get<TRESPONSE_GET_ALL_WORKSTATIONS_FOR_PRODUCTION_AREA>(url);
  }

  assignMachineToWorkstation(payload: TREQUEST_ASSIGN_MACHINE_TO_WORKSTATION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ASSIGN_MACHINE_TO_WORKSTATION');
    return this.http.post(url, payload);
  }

  removeMachineFromWorkstation(payload: TREQUEST_REMOVE_MACHINE_FROM_WORKSTATION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REMOVE_MACHINE_FROM_WORKSTATION');
    return this.http.post(url, payload);
  }

  replaceMachine(payload: TREQUEST_REPLACE_MACHINE_FROM_WORKSTATION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REPLACE_MACHINE_IN_WORKSTATION');
    return this.http.post(url, payload);
  }

  removeWorkstation(payload: TREQUEST_REMOVE_WORKSTATION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REMOVE_WORKSTATION');
    return this.http.post(url, payload);
  }

  resetFactoryProductionArea(payload: TREQUEST_RESET_FACTORY_PRODUCTION_AREA) {
    const url = this.mmEnvironmentService.getUrlFromEnv('RESET_PRODUCTION_AREA');
    return this.http.post(url, payload);
  }

  searchNeedleNumbers(searchStr: string) {
    const url = this.mmEnvironmentService.getUrlFromEnv('SEARCH_NEEDLE_NUMBERS');
    return this.http.post<TRESPONSE_NEEDLE_SEARCH>(url, { searchStr });
  }

  addMachineNeedles(payload: TREQUEST_ADD_MACHINE_NEEDLES) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ADD_MACHINE_NEEDLES');
    return this.http.post<void>(url, payload);
  }

  removeMachineNeedles(payload: TREQUEST_REMOVE_MACHINE_NEEDLES) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REMOVE_MACHINE_NEEDLES');
    return this.http.post<void>(url, payload);
  }

  getBrandsAndTypesByNeedleNumber(needleNumber: string) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_BRANDS_AND_TYPES_BY_NEEDLE_NUMBER');
    return this.http.post<TRESPONSE_GET_BRANDS_AND_TYPES_BY_NEEDLE_NUMBER>(url, { needleNumber });
  }

  getShiftScheduleLines() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ALL_LINES_FOR_FACTORY');
    return this.http.get<TRESPONSE_GET_ALL_SHIFT_SCHEDULE_LINE_LOCATIONS>(url);
  }

  getLineSetupTicketListing(payload: TREQUEST_LINE_SETUP_TICKET_LISTING) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_LISTING');
    return this.http.post<TRESPONSE_LINE_SETUP_TICKET_LISTING>(url, payload);
  }

  getLineSetupTicketDetails(lineSetupTicketId: TLineSetupTicketId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('LINE_SETUP_TICKET_DETAILS')
      .replace(':lineSetupTicketId', lineSetupTicketId.toString());
    return this.http.get<TRESPONSE_LINE_SETUP_TICKET_DETAILS>(url);
  }

  deleteLineSetupTicket(payload: TREQUEST_LINE_SETUP_TICKET_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_DELETE');
    return this.http.post<void>(url, payload);
  }

  updateLineSetupTicketMechanic(payload: TREQUEST_LINE_SETUP_TICKET_UPDATE_MECHANIC) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_UPDATE_MECHANIC');
    return this.http.post<void>(url, payload);
  }

  updateLineSetupTicket(payload: TREQUEST_LINE_SETUP_TICKET_UPDATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_UPDATE');
    return this.http.post<void>(url, payload);
  }

  createLineSetupTicketSubTask(payload: TREQUEST_LINE_SETUP_TICKET_SUBTASK_CREATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_SUBTASK_CREATE');
    return this.http.post<void>(url, payload);
  }

  deleteLineSetupTicketSubTask(payload: TREQUEST_LINE_SETUP_TICKET_SUBTASK_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_SUBTASK_DELETE');
    return this.http.post<void>(url, payload);
  }

  getLineSetupTicketSubTaskList(payload: TREQUEST_LINE_SETUP_TICKET_SUBTASK_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('LINE_SETUP_TICKET_SUBTASK_LIST');
    return this.http.post<TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST>(url, payload);
  }

  getAllAssignedMechanicsForLocation(locationId: string) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_ALL_ASSIGNED_MECHANICS_FOR_LOCATION')
      .replace(':locationId', locationId);
    return this.http.get<TRESPONSE_GET_ALL_ASSIGNED_MECHANICS_FOR_LOCATION>(url);
  }

  //Ticket management APIs
  getAllBreakdownReasonsAndSolutions(payload: TREQUEST_BREAKDOWN_REASON_SOLUTION_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_BREAKDOWN_REASON_SOLUTION_LIST');
    return this.http.post<TRESPONSE_BREAKDOWN_REASON_SOLUTION_LIST>(url, payload);
  }

  createNewTicket(payload: TREQUEST_CREATE_TICKET) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_NEW_TICKET');
    return this.http.post(url, payload);
  }

  assignTicketToMe(payload: TREQUEST_CREATE_TICKET) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ASSIGN_TICKET_TO_ME');
    return this.http.post(url, payload);
  }

  updateIssue(payload: TREQUEST_UPDATE_ISSUE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_ISSUE');
    return this.http.post(url, payload);
  }

  reAssignMechanic(payload: TREQUEST_REASSIGN_MECHANIC) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REASSIGN_MECHANIC');
    return this.http.post(url, payload);
  }

  reIssueTicket(factoryId: TFactoryId, ticketId: TTicketId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('REIUSSE_TICKET')
      .replace(':factoryId', factoryId)
      .replace(':ticketId', ticketId.toString());
    return this.http.post(url, {});
  }

  approveTicket(factoryId: TFactoryId, ticketId: TTicketId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('APPROVE_TICKET')
      .replace(':factoryId', factoryId)
      .replace(':ticketId', ticketId.toString());
    return this.http.post(url, {});
  }

  pickupTicket(factoryId: TFactoryId, ticketId: TTicketId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('PICKUP_TICKET')
      .replace(':factoryId', factoryId)
      .replace(':ticketId', ticketId.toString());
    return this.http.post(url, {});
  }

  markTicketAsCompleted(factoryId: TFactoryId, ticketId: TTicketId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('MARK_TICKET_COMPLETED')
      .replace(':factoryId', factoryId)
      .replace(':ticketId', ticketId.toString());
    return this.http.post(url, {});
  }

  getAllEmployeeTickets(payload: TREQUEST_GET_ALL_EMPLOYEE_TICKETS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ALL_EMPLOYEE_TICKETS');
    return this.http.post<TRESPONSE_GET_ALL_EMPLOYEE_TICKETS>(url, payload);
  }

  getEmployeeTicketDetails(ticketId: TTicketId) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_EMPLOYEE_TICKET_DETAILS');
    return this.http.post<TRESPONSE_GET_EMPLOYEE_TICKET_DETAILS>(url, { ticketId: ticketId });
  }

  getMachineTicketHistory(payload: TREQUEST_GET_MACHINE_TICKET_HISTORY) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_MACHINE_TICKET_HISTORY');
    return this.http.post<TRESPONSE_GET_MACHINE_TICKET_HISTORY>(url, payload);
  }

  getMachineMaintenanceHistory(payload: TREQUEST_GET_MACHINE_TICKET_HISTORY) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_MACHINE_MAINTENANCE_HISTORY');
    return this.http.post<TRESPONSE_GET_MAINTENANCE_TICKET_HISTORY>(url, payload);
  }

  getEmployeeTicketSummary(payload: TREQUEST_SUMMARY) {
    const url = this.mmEnvironmentService.getUrlFromEnv('EMPLOYEE_TICKET_SUMMARY');
    return this.http.post<TRESPONSE_GET_EMPLOYEE_TICKET_SUMMARY>(url, payload);
  }

  getTicketSummaryAnalytics(payload: TREQUEST_SUMMARY_ANALYTICS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('TICKET_SUMMARY_ANALYTICS');
    return this.http.post<TRESPONSE_GET_TICKET_SUMMARY_ANALYTICS>(url, payload);
  }

  getFactoryShiftRevisionDetails(payload: TREQUEST_GET_SHIFT_DETAILS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_FACTORY_SHIFT_REVISION');
    return this.http.post<TRESPONSE_GET_SHIFT_DETAILS>(url, payload);
  }

  addShiftRevisions(payload: TREQUEST_ADD_REVISION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ADD_SHIFT_REVISIONS');
    return this.http.post<void>(url, payload);
  }

  getLocationShifts(payload: TREQUEST_GET_LOCATION_SHIFTS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_LOCATION_SHIFTS');
    return this.http.post<TRESPONSE_GET_LOCATION_SHIFTS>(url, payload);
  }

  updateShiftRevision(payload: TREQUEST_UPDATE_REVISION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_SHIFT_REVISION');
    return this.http.post(url, payload);
  }

  deleteShiftRevision(shiftRevisionId: TShiftRevision['shiftRevisionId']) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('DELETE_SHIFT_REVISION')
      .replace(':shiftRevisionId', shiftRevisionId.toString());
    return this.http.post(url, {});
  }

  // Maintenance Ticket Management APIs
  getAllMaintenanceTickets(payload: TREQUEST_GET_ALL_MAINTENANCE_TICKETS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ALL_MAINTENANCE_TICKETS');
    return this.http.post<TRESPONSE_GET_ALL_MAINTENANCE_TICKETS>(url, payload);
  }

  markChecklistCompleted(payload: TREQUEST_MARK_CHECKLIST_COMPLETED) {
    const url = this.mmEnvironmentService.getUrlFromEnv('MARK_CHECKLIST_COMPLETED');
    return this.http.post(url, payload);
  }

  createMaintenanceTicket(payload: TREQUEST_CREATE_MAINTENANCE_TICKET) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_MAINTENANCE_TICKET');
    return this.http.post(url, payload);
  }

  startMaintenanceTicket(payload: TREQUEST_START_MAINTENANCE_TICKET) {
    const url = this.mmEnvironmentService.getUrlFromEnv('START_MAINTENANCE_TICKET');
    return this.http.post(url, payload);
  }

  completeMaintenanceTicket(payload: TREQUEST_COMPLETE_MAINTENANCE_TICKET) {
    const url = this.mmEnvironmentService.getUrlFromEnv('COMPLETE_MAINTENANCE_TICKET');
    return this.http.post(url, payload);
  }

  reAssignMaintenanceMechanic(payload: TREQUEST_REASSIGN_MAINTENANCE_MECHANIC) {
    const url = this.mmEnvironmentService.getUrlFromEnv('REASSIGN_MAINTENANCE_MECHANIC');
    return this.http.post(url, payload);
  }

  //Sparepart ticket APIS

  searchSparepartNames(searchStr: string) {
    const url = this.mmEnvironmentService.getUrlFromEnv('SPAREPART_SEARCH_NAMES');
    return this.http.post<TRESPONSE_SPAREPART_SEARCH_NAMES>(url, { searchStr });
  }

  getAllBrandsAndSpecificationsByName(payload: TREQUEST_GET_ALL_BRANDS_AND_SPECIFICATIONS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ALL_BRANDS_AND_SPECIFICATIONS_BY_NAME');
    return this.http.post<TRESPONSE_GET_ALL_BRANDS_AND_SPECIFICATIONS>(url, payload);
  }

  createSparepartRequest(payload: TREQUEST_RAISE_SPAREPART_REQUEST | TREQUEST_RAISE_NEEDLE_REQUEST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_SPAREPART_REQUEST');
    return this.http.post(url, payload);
  }

  getSparepartRequestBySource(payload: TREQUEST_GET_SPAREPART_REQUEST_BY_SOURCE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_SPAREPART_REQUEST_BY_SOURCE');
    return this.http.post<TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE>(url, payload);
  }

  cancelSparepartRequest(requestId: TRaiseARequestId) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('CANCEL_SPAREPART_REQUEST')
      .replace(':requestId', requestId.toString());
    return this.http.post(url, null);
  }

  getSparepartRequestReasons(
    sparePartType: TRESPONSE_GET_SPAREPART_REQUEST_BY_SOURCE['requests'][number]['sparePartType'],
  ) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_SPAREPART_REQUEST_REASONS')
      .replace(':sparePartType', sparePartType);

    return this.http.get<GET_SPAREPART_REQUEST_REASONS>(url);
  }

  // Needle List APIs
  fetchNeedleList(payload: TREQUEST_NEEDLE_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('FETCH_NEEDLE_LIST_DATA');
    return this.http.post<TRESPONSE_NEEDLE_LIST>(url, payload);
  }

  getNeedleListDropdownData() {
    const url = this.mmEnvironmentService.getUrlFromEnv('NEEDLE_LIST_DROPDOWN_VALUES');
    return this.http.get<TRESPONSE_UPDATE_NEEDLE_FIELD_DROPDOWN>(url);
  }

  updateNeedle(payload: TREQUEST_NEEDLE_UPDATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_NEEDLE');
    return this.http.post<void>(url, payload);
  }

  deleteNeedle(payload: TREQUEST_NEEDLE_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_NEEDLE');
    return this.http.post<void>(url, payload);
  }

  getBrandAndTypeByNeedleNumber(needleNumber: string) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_BRAND_AND_TYPE_BY_NEEDLE_NUMBER');
    return this.http.post<TRESPONSE_GET_BRAND_AND_TYPE_BY_NEEDLE_NUMBER>(url, { needleNumber });
  }

  raiseNeedleRequest(payload: TRAISE_NEEDLE_REQUEST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('RAISE_NEEDLE_REQUEST');
    return this.http.post<void>(url, payload);
  }

  //Approvals - Needle Request APIs
  getNeedleRequestList(payload: TREQUEST_SPAREPART_REQUEST_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_NEEDLE_REQUEST_LIST');
    return this.http.post<TRESPONSE_GET_NEEDLE_REQUESTS>(url, payload);
  }

  bulkUpdateNeedleRequest(payload: TREQUEST_BULK_UPDATE_SPAREPART_REQUEST_STATUS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('BULK_NEEDLE_REQUEST_UPDATE');
    return this.http.post(url, payload);
  }

  approveNeedleRequest(payload: TREQUEST_NEEDLE_APPROVE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('APPROVE_NEEDLE_REQUEST');
    return this.http.post<void>(url, payload);
  }

  //Requests - Needle APIs
  getLocalStoreRequests(payload: TREQUEST_SPAREPART_REQUEST_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_LOCAL_STORE_REQUESTS');
    return this.http.post<TRESPONSE_LOCAL_NEEDLE_STORE_REQUEST>(url, payload);
  }

  // NPT
  getNptLinesDetails(payload: TREQUEST_LINES_NPT_DETAILS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_LINES_WITH_NPT');
    return this.http.post<TRESPONSE_LINES_NPT_DETAILS>(url, payload);
  }

  getNptWorkstationsDetails(payload: TREQUEST_WORKSTATIONS_NPT_DETAILS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_WORKSTATIONS_WITH_NPT');
    return this.http.post<TRESPONSE_WORKSTATIONS_NPT_DETAILS>(url, payload);
  }

  getWorkstationNpts(payload: TREQUEST_WORKSTATION_NPTS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_WORKSTATION_NPTS');
    return this.http.post<TRESPONSE_WORKSTATION_NPTS>(url, payload);
  }

  createNpt(payload: TREQUEST_NPT_CREATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_NPT');
    return this.http.post<void>(url, payload);
  }

  createBulkNpt(payload: TREQUEST_BULK_NPT_CREATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_BULK_NPT');
    return this.http.post<void>(url, payload);
  }

  getFactoryLevelNpts(date: TDate) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_FACTORY_LEVEL_NPTS');
    return this.http.post<TRESPONSE_FACTORY_LEVEL_NPTS>(url, { date });
  }

  createNptInPast(payload: TREQUEST_NPT_CREATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_NPT_IN_PAST');
    return this.http.post<void>(url, payload);
  }

  deleteNpt(payload: TREQUEST_NPT_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_NPT');
    return this.http.post<void>(url, payload);
  }
  deleteNptInPast(payload: TREQUEST_NPT_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_NPT_IN_PAST');
    return this.http.post<void>(url, payload);
  }

  editNpt(payload: TREQUEST_NPT_EDIT) {
    const url = this.mmEnvironmentService.getUrlFromEnv('EDIT_NPT');
    return this.http.post<void>(url, payload);
  }
  editNptInPast(payload: TREQUEST_NPT_EDIT) {
    const url = this.mmEnvironmentService.getUrlFromEnv('EDIT_NPT_IN_PAST');
    return this.http.post<void>(url, payload);
  }

  fetchNptReasonsList(payload: TREQUEST_NPT_REASONS_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_NPT_REASONS_LIST');
    return this.http.post<TRESPONSE_NPT_REASONS_LIST>(url, payload);
  }

  deleteNptReasonSubcategory(payload: TREQUEST_NPT_SUBCATEGORY_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_NPT_REASON_SUBCATEGORY');
    return this.http.post<void>(url, payload);
  }

  // Attachment
  fetchAttachmentList(payload: TREQUEST_ATTACHMENT_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ATTACHMENT_LIST');
    return this.http.post<TRESPONSE_ATTACHMENT_LIST>(url, payload);
  }
  deleteAttachments(payload: TREQUEST_ATTACHMENT_DELETE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('DELETE_ATTACHMENT');
    return this.http.post<void>(url, payload);
  }
  printAttachmentsQrCodes(payload: TREQUEST_ATTACHMENT_PRINT_QR) {
    const url = this.mmEnvironmentService.getUrlFromEnv('PRINT_ATTACHMENT_QR_CODE');
    return this.http.post<void>(url, payload);
  }
  updateAttachment(payload: TREQUEST_ATTACHMENT_UPDATE) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_ATTACHMENT');
    return this.http.post<void>(url, payload);
  }
  fetchAttachmentApprovalList(payload: TREQUEST_ATTACHMENT_APPROVAL_LIST) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ATTACHMENT_APPROVAL_LIST');
    return this.http.post<TRESPONSE_ATTACHMENT_APPROVAL_LIST>(url, payload);
  }
  updateAttachmentByAction(payload: TREQUEST_ATTACHMENT_ACTION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_ATTACHMENT_BY_ACTION');
    return this.http.post<void>(url, payload);
  }
  updateAttachmentApprovalByAction(payload: TREQUEST_ATTACHMENT_APPROVAL_ACTION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('UPDATE_ATTACHMENT_APPROVAL_BY_ACTION');
    return this.http.post<void>(url, payload);
  }
  getAttachmentDetailsBySerialNum(serialNum: TAttachmentSerialNumber) {
    const url = this.mmEnvironmentService
      .getUrlFromEnv('GET_ATTACMENT_DETAILS_BY_SERIAL_NUMBER')
      .replace(':attachmentSerialNumber', serialNum);
    return this.http.get<TRESPONSE_GET_ATTACHMENT_DETAILS_BY_SERIAL_NUM>(url);
  }

  // CHATBOT
  knowledgeBaseAskQuestion(payload: TREQUEST_KNOWLEDGE_BASE_QUESTION) {
    const url = this.mmEnvironmentService.getUrlFromEnv('KNOWLEDGE_BASE_QUESTION');
    return this.http.post<TRESPONSE_KNOWLEDGE_BASE_QUESTION>(url, payload, {
      headers: new HttpHeaders({ [DISABLE_ERROR_ALERT_HEADER]: 'true' }),
    });
  }

  knowledgeBaseSubmitFeedback(payload: TREQUEST_KNOWLEDGE_BASE_SUBMIT_FEEDBACK) {
    const url = this.mmEnvironmentService.getUrlFromEnv('KNOWLEDGE_BASE_SUBMIT_FEEDBACK');
    return this.http.post<void>(url, payload);
  }

  // multi shift management
  getAllShifts(payload: TREQUEST_MM_GET_ALL_SHIFTS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_ALL_SHIFTS');
    return this.http.post<TRESPONSE_MM_GET_ALL_SHIFTS>(url, payload);
  }
  getLineShifts(payload: TREQUEST_GET_LINES_SHIFTS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_LINE_SHIFTS');
    return this.http.post<TRESPONSE_GET_LINES_SHIFTS>(url, payload);
  }
  assignShiftToLocations(payload: TREQUEST_ASSIGN_SHIFT_TO_LOCATIONS) {
    const url = this.mmEnvironmentService.getUrlFromEnv('ASSIGN_SHIFT_TO_LOCATIONS');
    return this.http.post<void>(url, payload);
  }
  createShiftCategory(payload: TREQUEST_CREATE_SHIFT_CATEGORY) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_SHIFT_CATEGORY');
    return this.http.post<void>(url, payload);
  }
  createShift(payload: TREQUEST_CREATE_SHIFT) {
    const url = this.mmEnvironmentService.getUrlFromEnv('CREATE_SHIFT');
    return this.http.post<void>(url, payload);
  }
  getShiftCategories() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_SHIFT_CATEGORIES');
    return this.http.get<TRESPONSE_GET_SHIFT_CATEGORIES>(url);
  }
  getFactoryTimeZone() {
    const url = this.mmEnvironmentService.getUrlFromEnv('GET_FACTORY_TIME_ZONE');
    return this.http.get<TRESPONSE_GET_FACTORY_TIME_ZONE>(url);
  }
}
